import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const isActive = (pathname, itemPath) => {
  if (itemPath === '/') return pathname === '/';
  return pathname.startsWith(itemPath);
};

export const MobileMenu = ({ isOpen, setIsOpen, primaryNav, secondaryNav, location }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        className="fixed inset-0 z-40 lg:hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="absolute inset-0 bg-background/95 backdrop-blur-lg" onClick={() => setIsOpen(false)} />
        <motion.nav
          className="absolute top-20 left-0 right-0 p-6 flex flex-col gap-2"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
        >
          {[...primaryNav, { name: 'Contact', path: '/contact' }].map((link, index) => {
            const active = isActive(location.pathname, link.path);
            return (
              <motion.div
                key={link.path}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.04 }}
              >
                {active ? (
                  <span
                    className="block text-lg font-semibold py-2 text-primary border-l-2 border-primary pl-4 cursor-default"
                    data-testid={`mobile-nav-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </span>
                ) : (
                  <Link
                    to={link.path}
                    className="block text-lg font-medium py-2 text-white hover:text-primary transition-colors pl-4"
                    data-testid={`mobile-nav-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                )}
              </motion.div>
            );
          })}

          <motion.div
            className="border-t border-border/30 mt-2 pt-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.25 }}
          >
            <span className="text-xs uppercase tracking-widest text-muted-foreground pl-4 mb-2 block">More</span>
            {secondaryNav.map((link, index) => {
              const active = isActive(location.pathname, link.path);
              return (
                <motion.div
                  key={link.path}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.3 + index * 0.03 }}
                >
                  {active ? (
                    <span
                      className="block text-base font-semibold py-1.5 text-primary border-l-2 border-primary pl-4 cursor-default"
                      data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                    >
                      {link.name}
                    </span>
                  ) : (
                    <Link
                      to={link.path}
                      className="block text-base font-medium py-1.5 text-slate-400 hover:text-primary transition-colors pl-4"
                      data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                    >
                      {link.name}
                    </Link>
                  )}
                </motion.div>
              );
            })}
          </motion.div>
        </motion.nav>
      </motion.div>
    )}
  </AnimatePresence>
);
